import * as React from 'react';
import AppointmentPickDifferentTimeSlotContent from './AppointmentPickDifferentTimeSlotContent.js';

const AppointmentPickDifferentTimeSlot = ({ labels , loading , onClickPrevious , onSelectTimeSlot , selected , timeSlots  })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: "appointment-pick-different-time-slot"
    }, /*#__PURE__*/ React.createElement(AppointmentPickDifferentTimeSlotContent, {
        labels: labels,
        loading: loading,
        onClickPrevious: onClickPrevious,
        onSelectTimeSlot: onSelectTimeSlot,
        selected: selected,
        timeSlots: timeSlots
    }));
};
var AppointmentPickDifferentTimeSlot$1 = AppointmentPickDifferentTimeSlot;

export { AppointmentPickDifferentTimeSlot$1 as default };
//# sourceMappingURL=AppointmentPickDifferentTimeSlot.js.map
